import React from "react";
import Hero from "@/components/sections/Hero";
import QuickServices from "@/components/sections/QuickServices";
import Manifesto from "@/components/sections/Manifesto";
import Statistics from "@/components/sections/Statistics";
import EditorialMarquee from "@/components/sections/Marquee";
import UpcomingEvents from "@/components/sections/UpcomingEvents";
import Initiatives from "@/components/sections/Initiatives";
import GallerySection from "@/components/sections/GallerySection";
import LatestUpdates from "@/components/sections/LatestUpdates";
import Testimonials from "@/components/sections/Testimonials";
import FAQSection from "@/components/sections/FAQSection";
import ContactSection from "@/components/sections/ContactSection";

export default function Home() {
    return (
        <div data-testid="home-page">
            <Hero />
            <QuickServices />
            <Manifesto />
            <Statistics />
            <EditorialMarquee />
            <UpcomingEvents />
            <Initiatives />
            <GallerySection compact />
            <LatestUpdates />
            <Testimonials />
            <FAQSection />
            <ContactSection />
        </div>
    );
}
